<template>
  <div>
    <ModalCover :show_close="false" modal_style="rounded-1 modal-large">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body" class="exam-proctor-report-modal">
        <!-- MODAL TOP -->
        <div class="container-fluid report-top">
          <div
            class="title-row d-flex justify-content-between align-items-center nowrap"
          >
            <div class="title-text color_text">
              Exam Proctor Report
            </div>

            <div
              class="close-bar avatar position-relative color_white_bg pointer"
              @click="$emit('close-triggered')"
            >
              <span class="icon-decline font-18 flex-center"></span>
            </div>
          </div>
        </div>

        <!-- MODAL BODY -->
        <div class="report-bottom">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-7">
                <StudentProctorReportBlock
                  :proctor="proctor"
                ></StudentProctorReportBlock>
              </div>

              <div class="col-12 col-md-5">
                <ProctorIntegrityCard :proctor="proctor"></ProctorIntegrityCard>
              </div>
            </div>

            <div class="bottom-modals border-top">
              <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <button
                  class="btn btn-sm btn-default-outline d-flex justify-content-between align-items-center"
                  @click="rejectSubmission"
                >
                  <div class="icon-empty-trash font-17 flex-center mr-2"></div>
                  <div class="text">Reject Submission</div>
                </button>

                <button
                  class="btn btn-sm btn-default-outline d-flex justify-content-between align-items-center"
                  @click="reportToAdmin"
                >
                  <div
                    class="icon-status-indicator font-17 flex-center mr-2"
                  ></div>
                  <div class="text">Report to Admin</div>
                </button>
              </div>
              <div class="right">
                <button
                  class="btn btn-sm btn-default-outline d-flex justify-content-around align-items-center"
                  @click="$emit('close-triggered')"
                >
                  <div class="icon-decline font-17 flex-center"></div>
                  <div class="text">Exit</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalCover>

    <RejectSubmissionModal
      v-if="reject_submission"
      :proctor="proctor"
      @closeTriggered="closeRejectTriggered"
    ></RejectSubmissionModal>
    
    <ReportToAdminModal
      v-if="report_to_admin"
      :proctor="proctor"
      @closeTriggered="closeReportTriggered"
    ></ReportToAdminModal>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "ExamProctorReportModal",
  props: ["proctor"],
  components: {
    ModalCover,
    StudentProctorReportBlock: () =>
      import(
        /* webpackChunkName: "StudentProctorReportBlock" */ "@/components/classComps/homework/homework_review/StudentProctorReportBlock"
      ),
    ProctorIntegrityCard: () =>
      import(
        /* webpackChunkName: "ProctorIntegrityCard" */ "@/components/classComps/homework/homework_review/ProctorIntegrityCard"
      ),
    RejectSubmissionModal: () =>
      import(
        /* webpackChunkName: "ColouredIcon" */ "@/components/modalComps/classModals/RejectionSubmissionModal"
      ),
    ReportToAdminModal: () =>
      import(
        /* webpackChunkName: "ColouredIcon" */ "@/components/modalComps/classModals/ReportToAdminModal"
      ),
  },
  data() {
    return {
      reject_submission: false,
      report_to_admin: false,
    };
  },
  methods: {
    rejectSubmission() {
      this.reject_submission = !this.reject_submission;
    },
    reportToAdmin() {
      this.report_to_admin = !this.report_to_admin;
    },
    closeRejectTriggered() {
      this.reject_submission = !this.reject_submission;
    },
    closeReportTriggered() {
      this.report_to_admin = !this.report_to_admin;
    },
  },
};
</script>

<style lang="scss" scoped>
.exam-proctor-report-modal {
  .report-top {
    padding: 25px;
    .title-row {
      .title-text {
        font-size: 21px;
        line-height: 22px;
        font-weight: 900;
      }

      .close-bar {
        span {
          color: $border_grey_dark;
          transition: all 0.3s ease-in-out;
        }
        &:hover {
          span {
            color: $color_text;
          }
        }
      }
    }
  }

  .report-bottom {
    padding: 5px 10px 20px;

    .bottom-modals {
      @include flex_row_between_nowrap;
      padding-top: 15px;
      padding-bottom: 0px;

      .btn {
        padding: 9px 12px;
        &:hover {
          color: $brand_accent !important;
        }
      }
    }
  }
}
</style>
